/**
 * After a deploy, a tab opened on the previous build still asks for that build's code chunks, which no longer exist
 * (file names carry a content hash). Loading the screen then fails with "Failed to fetch dynamically imported module".
 * Reloading once picks up the new build; the guard stops a reload loop if the failure is something else.
 */

const KEY = "pulse.stale-build-reload";
const WINDOW_MS = 30_000;

const PATTERNS = [
  /Failed to fetch dynamically imported module/i, // Chrome, Edge
  /error loading dynamically imported module/i, // Firefox
  /Importing a module script failed/i, // Safari
  /Unable to preload CSS/i, // Vite CSS preload
];

export function isStaleBuildError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === "string" ? error : "";
  return PATTERNS.some((p) => p.test(message));
}

/** Reload the page, unless this tab already did so in the last 30 seconds. Returns whether it reloads. */
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(window.sessionStorage.getItem(KEY) ?? 0);
    if (Date.now() - last < WINDOW_MS) return false;
    window.sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    // Storage blocked: still reload once; the browser's own cache-busting makes a loop unlikely.
  }
  window.location.reload();
  return true;
}
